import { render, staticRenderFns } from "./NewPhotoBookCard.vue?vue&type=template&id=1c841818"
import script from "./NewPhotoBookCard.vue?vue&type=script&lang=js"
export * from "./NewPhotoBookCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports